import { request } from '../request'

export function search(query) {
  return request(`/categories.json?query=${query}`)
}

export function find(id) {
  return request(`/categories/${id}.json`)
}
